import { fixAllGrammarErrors } from './logic';

export const handleHotKeys = (event: KeyboardEvent) => {
  if (window.location.pathname !== '/grammar-check') {
    return;
  }
  // Ctrl + Enter => Fix All Errors
  if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
    fixAllGrammarErrors('hotkey');
  }
};
